'use client';

import Link from '@eliadmin/core/src/components/link';
import React from 'react';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from './button';

interface SubpageHeaderProps {
  title?: string;
  breadcrumbs?: {
    label: string;
    href: string;
  }[];
  button?: {
    label: string;
    href: string;
  };
}

export function SubpageHeader({ title, breadcrumbs, button }: SubpageHeaderProps) {
  const { t } = useTranslations();

  return (
    <section
      className={cn(
        'custom-section',
        'ea-subpage-header',
        'relative pb-24 pt-[100px] sm:pt-[180px] md:pt-[210px] lg:pt-[240px]',
      )}
    >
      <div className={cn('custom-container', 'flex flex-row items-end justify-between gap-6')}>
        <div className="flex w-full flex-col items-start justify-start gap-6">
          <div className="flex items-start justify-start gap-2">
            <Link
              prefetch={false}
              href={ROUTES.HOME()}
              className="text-sm font-semibold text-white transition-all hover:opacity-80"
            >
              {t('text160')}
            </Link>
            {breadcrumbs && (
              <>
                <span className="text-sm font-semibold text-white/50">/</span>
                {breadcrumbs.map((breadcrumb, index) => (
                  <React.Fragment key={index}>
                    <Link
                      prefetch={false}
                      href={breadcrumb.href}
                      className="text-sm font-semibold text-white transition-all hover:opacity-80"
                    >
                      {breadcrumb.label}
                    </Link>
                  </React.Fragment>
                ))}
              </>
            )}
          </div>
          {title && <h1 className={cn('h1', 'font-semibold uppercase text-white')}>{title}</h1>}
        </div>
        {button && (
          <Button asChild variant={'white'} className="whitespace-nowrap">
            <Link prefetch={false} href={button?.href}>
              {button?.label}
            </Link>
          </Button>
        )}
      </div>
    </section>
  );
}
